import styled from 'styled-components';

export const FooterStyles = styled.footer`
  position: relative;
  padding: 40px 0;
  background: #161924;
  
  @media (max-width: 850px) {
    padding: 56px 0;
  }
  
  @media (min-width: 851px) {
    &::after {
      content: '';
      position: absolute;
      bottom: 120px;
      left: 0;
      width: 100%;
      height: 1px;
      background: #293046;
    }
  }
  
  .content {
    display: flex;
    justify-content: space-between;

    @media (max-width: 850px) {
      flex-direction: column;
      justify-content: center;
      align-items: center;
      text-align: center;
    }
    
    a {
      color: #FFF;
      transition: 0.3s ease all;

      &:hover {
        color: #FFC228;
      }
    }
    
    .title {
      color: #FFC228;
      font-weight: 800;
      font-size: 18px;
      line-height: 26px;
      display: inline-block;
      margin-bottom: 24px;

      @media (max-width: 850px) {
        margin-bottom: 12px;
      }
    }
    
    .logoAndTermsWrapper {
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      @media (max-width: 850px) {
        margin-bottom: 32px;
        align-items: center;
      }
      
      .logoContainer {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 24px;
        max-width: 80px;

        @media (max-width: 850px) {

        }
        
        .socialLinksContainer {
          display: flex;
          
          a:nth-child(1) {
            margin-right: 16px;

            @media (max-width: 850px) {

            }
            
            svg {
              circle {
                transition: 0.3s ease all;
              }
              
              &:hover {
                circle {
                  fill: #3b5998;
                  stroke: #3b5998;
                }
              }
            }
          }
          
          a:nth-child(2) {
            margin-right: 16px;
            
            svg {
              circle {
                transition: 0.3s ease all;
              }
              
              &:hover {
                circle {
                  fill: #e1306c;
                  stroke: #e1306c;
                }
              }
            }
          }

          a:nth-child(3) {
            svg {
              width: 32px;
              height: 32px;
              
              path {
                fill: #FFC228;

                transition: 0.3s ease fill;
              }

              &:hover {
                path {
                  fill: #0088cc;
                }
              }
            }
          }
        }
      }

      .termsContainer {
        display: grid;
        gap: 4px;
        font-weight: 400;
        font-size: 16px;
        line-height: 24px;
        color: #FFC228;

        @media (max-width: 850px) {
          display: none;
        }
      }
    }
    
    .listWrapper {
      .head {
        margin-bottom: 100px;

        @media (max-width: 850px) {
          margin-bottom: 0;
        }
      }
      
      .link {
        display: block;
        transform: translateY(-17px);

        @media (max-width: 850px) {
          display: none;
        }
      }
      
      ul {
        display: grid;
        gap: 8px;
        
        font-weight: 400;
        font-size: 16px;
        line-height: 24px;

        @media (max-width: 850px) {
          margin-bottom: 32px;
        }
        
        a {
          position: relative;
          
          &::before {
            content: '';
            position: absolute;
            bottom: -1px;
            left: 0;
            width: 0;
            height: 1px;
            background: #FFC228;
            transition: 0.3s ease all;
          }
        }
        
        a:hover {
          &::before {
            width: 100%;
          }
        }
      }
    }
    
    .contactsWrapper {
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      @media (max-width: 850px) {
        margin-bottom: 32px;
      }
      
      .head {
        max-width: 203px;
      }
      
      .privacyPolicyLink {
        transform: translateY(-17px);

        @media (max-width: 850px) {
          display: none;
        }
      }
      
      .contactsLinks {
        display: grid;
        gap: 8px;

        @media (max-width: 850px) {

        }
      }
    }
    
    .splitterMobile {
      width: 100%;
      height: 1px;
      background: #293046;
      margin-bottom: 40px;
      
      @media (min-width: 851px) {
        display: none;
      }
    }
    
    .termsMobileWrapper {
      display: none;
      
      @media (max-width: 850px) {
        display: grid;
        gap: 32px;
      }
    }
    
    .termsMobile {
      display: none;
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
      color: #FFC228;
      
      @media (max-width: 850px) {
        display: grid;
        gap: 4px;
      }
    }
  }
`;
